import { InputAdornment, IconButton } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useState } from "react";

const useLoginFields = () => {
  const [showPassword, setShowPassword] = useState(false);

  const loginFields = [
    {
      name: "email",
      label: "Email Address*",
      size: 12,
      maxlength: 254,
    },
    {
      name: "password",
      label: "Password*",
      size: 12,
      type: showPassword ? "text" : "password",
      InputProps: {
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={() => setShowPassword((show) => !show)}
              onMouseDown={(event) => event.preventDefault()}
              edge="end"
            >
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        ),
      },
    },
  ];

  return { loginFields };
};

export default useLoginFields;
